import { motion } from "framer-motion";
import { RevealMask } from "@/components/motion/Reveal";
import ScrambleText from "@/components/motion/ScrambleText";
import { manifesto } from "@/data/content";

export default function WhyHashtag() {
  return (
    <section data-testid="why-hashtag" className="relative mx-auto max-w-[1600px] overflow-hidden px-5 py-16 pb-12 sm:px-8 md:px-10 lg:px-12 xl:px-16 md:py-28 md:pb-20 lg:py-36 lg:pb-28 xl:py-40 xl:pb-32">
      <span
        aria-hidden="true"
        className="stroke-ink pointer-events-none absolute -left-10 top-1/3 select-none font-display text-[38vw] font-extrabold leading-none opacity-[0.04] md:text-[24vw]"
      >
        #
      </span>
      <div className="relative mb-10 sm:mb-12 md:mb-16">
        <ScrambleText as="p" text="Why HashTag" className="mb-4 block text-xs font-bold uppercase tracking-[0.22em] text-accent" />
        <RevealMask as="h2" className="font-display text-5xl font-extrabold leading-[0.95] tracking-tight text-ink md:text-7xl">
          How we think.
        </RevealMask>
      </div>

      <div className="relative grid gap-x-10 gap-y-10 sm:gap-y-14 md:grid-cols-2 lg:gap-x-16">
        {manifesto.map((c, i) => (
          <motion.div
            key={c.n}
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-10%" }}
            transition={{ duration: 0.8, delay: (i % 2) * 0.1, ease: [0.76, 0, 0.24, 1] }}
            className="border-t border-line pt-8"
          >
            <span className="font-serif text-6xl font-normal italic text-accent md:text-7xl">{c.n}</span>
            <h3 className="mt-4 font-display text-3xl font-extrabold text-ink md:text-4xl">{c.title}</h3>
            <p className="mt-4 max-w-md text-base leading-relaxed text-muted md:text-lg">{c.body}</p>
          </motion.div>
        ))}
      </div>
    </section>
  );
}
